import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { API_URLS } from '../core/api-url.enum';
import { ApiCallService } from './api-call.service';
import { CommonService } from '../modules/shared/services/common.service';
@Injectable({
  providedIn: 'root'
})
export class DataService {
  deviceIP: string;
  transactionDetails: any;
  userProfile: any;
  commentSheetChange$ = new Subject<any>();
  postDetailChange$ = new Subject<any>();
  delegateDetails = null;
  delegateAccessList = [];
  delegateAccessList$ = new BehaviorSubject<any[]>([]);
  verifiedDelegatedAccessToken = [];
  creatorCategoriesData = null;
  creatorCategoriesData$ = new BehaviorSubject<any>(null);
  internalSubscriptionLockData$ = new BehaviorSubject<any>(null);
  internalNFTLockData$ = new BehaviorSubject<any>(null);

  private isDelegateAccessListLoading = false;

  constructor(
    private readonly apiCallService: ApiCallService,
    private readonly cs: CommonService
  ) {}

  setTransactionDetails(transactionDetails: any) {
    this.transactionDetails = transactionDetails;
  }

  getTransactionDetails() {
    return this.transactionDetails;
  }

  setDeviceIP(deviceIP: string) {
    this.deviceIP = deviceIP;
  }

  getDeviceIp() {
    return this.deviceIP;
  }

  notifyAboutPostDetailsChange(postDetailData: any) {
    this.postDetailChange$.next(postDetailData);
  }

  notifyAboutCommentSheetChange(commentsData: any) {
    this.commentSheetChange$.next(commentsData);
  }
  setCreatorCategoryData(categoryData: any) {
    this.creatorCategoriesData$.next(categoryData);
  }

  setDelegateDetails(val) {
    this.delegateDetails = val;
  }

  getDelegatedAccessList() {
    if (this.isDelegateAccessListLoading) {
      return;
    }
    this.isDelegateAccessListLoading = true;
    this.apiCallService.get(`${API_URLS.delegatedAccessList}`, false).subscribe(
      (res) => {
        this.isDelegateAccessListLoading = false;
        if (res.status) {
          this.delegateAccessList = res.data;
          this.verifiedDelegatedAccessToken = res.verified_delegate_access;
          this.delegateAccessList$.next(this.delegateAccessList);
        }
      },
      (err) => {
        this.isDelegateAccessListLoading = false;
        this.delegateAccessList = [];
        this.verifiedDelegatedAccessToken = [];
        this.delegateAccessList$.next(this.delegateAccessList);
        this.cs.showErrorMessage(err.message);
      }
    );
  }
}
